let user = localStorage.getItem("loginuser")
  ? JSON.parse(localStorage.getItem("loginuser"))
  : false;

export const initialState = {
  userDetails: "",
  loggedIn: user,
  loading:false,
  errorMessage: null
}

export const UserReducer = (state, action) => {
    switch (action.type) {
        case "REQUEST_LOGIN":
            return {
                ...initialState,
                loading:true
            }
        case "LOGIN_SUCCESS":
            return {
                ...initialState,
                user: action.payload,
                loggedIn: true,
                loading: false
            }
        case "LOGOUT":
            return {
                ...initialState,
                user: "",
                loggedIn: false
            };
        case "LOGIN_ERROR":
            return {
                ...initialState,
                loading: false,
                errorMessage: action.payload
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}